import React, { Component, Suspense } from 'react'
import { HashRouter, BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))

// Pages
const Login = React.lazy(() => import('./views/auth/Login'))
const FindAccount = React.lazy(() => import('./views/auth/FindAccount'))
const Register = React.lazy(() => import('./views/auth/Register'))
const Page404 = React.lazy(() => import('./views/auth/Page404'))
const Payment = React.lazy(()=> import('./views/auth/Payment'))

class App extends Component {
  render() {
    return (
      <BrowserRouter basename=''>
        <Suspense fallback={loading}>
          <Routes>
            <Route exact path="/login" name="Login Page" element={<Login />} />
            <Route exact path="/register" name="Register Page" element={<Register />} />
            <Route exact path="/findaccount" name="Find Account" element={<FindAccount />} />
            <Route exact path="/payment" name="payment" element={<Payment />} />
            <Route exact path="/404" name="Page 404" element={<Page404 />} />
            <Route path="*" name="Home" element={<DefaultLayout />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
}

export default App
